"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducers = void 0;
var Policy = require("./PolicyStore");
var UCM = require("./UCMStore");
var UI = require("./UIStore");
var Auth = require("./AuthStore");
var Jobs = require("./JobStore");
var BatchJobSettings = require("./BatchJobSettingsStore");
var DeleteCmtData = require("./DeleteCmtDataStore");
var Dashboard = require("./DashboardStore");
// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
exports.reducers = {
    drivers: Policy.reducer,
    ucms: UCM.reducer,
    jobs: Jobs.reducer,
    ui: UI.reducer,
    loggedInUser: Auth.reducer,
    bjss: BatchJobSettings.reducer,
    dcds: DeleteCmtData.reducer,
    dshs: Dashboard.reducer,
};
//# sourceMappingURL=index.js.map